import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_SUPPORT } from "../domain";

import { sendMailApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_SEND_SUPPORT_EMAIL = "SEND_SUPPORT_EMAIL";

const allowedRoles = [UserRole.Owner, UserRole.Admin];

const sendGetInTouchEmail = async (): Promise<void> => {
  await sendMailApi.sendSupportControllerSendGetInTouchEmail();

  return;
};

export const useGetInTouch = (
  user: UserProfileDto | null,
): {
  sendGetInTouchEmailAsync: () => Promise<void>;
  sendGetInTouchEmailEnabled: boolean;
  isSuccessCreateProcurementSupplier: boolean;
  isPendingCreateProcurementSupplier: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_SUPPORT, ACTION_SEND_SUPPORT_EMAIL],
    mutationFn: enabled ? sendGetInTouchEmail : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_SUPPORT, ACTION_SEND_SUPPORT_EMAIL],
      });
    },
  });

  return {
    sendGetInTouchEmailAsync: mutateAsync,
    sendGetInTouchEmailEnabled: enabled,
    isSuccessCreateProcurementSupplier: isSuccess,
    isPendingCreateProcurementSupplier: isPending,
  };
};
